import styled, { css } from "styled-components";

export interface BaseGridContainerProps {
	gridWidth?: number | string;
	gridHeight?: number | string;
}
export const BaseGridContainer = styled.section`
	margin: 0 auto;
	position: relative;

	${({ gridWidth }: BaseGridContainerProps) => {
		if (typeof gridWidth === "number" && gridWidth) {
			return css`
				width: ${gridWidth}px;
			`;
		}
		return css`
			width: ${gridWidth || "100%"};
		`;
	}}
	${({ gridHeight }: BaseGridContainerProps) => {
		if (typeof gridHeight === "number" && gridHeight) {
			return css`
				height: ${gridHeight}px;
			`;
		}
		return css`
			height: ${gridHeight || "auto"};
		`;
	}}
`;
